import { __assign } from "tslib";
export var roundingGlobals = {
    sm: 2,
    md: 4,
    lg: 8,
    xl: 10,
    xxl: 12,
};
export var createRoundingAliases = function (rounding) {
    return {
        raisedSurface: rounding.md,
    };
};
export var createRoundingGlobals = function () {
    return roundingGlobals;
};
export var createRounding = function () {
    var aliases = createRoundingAliases(roundingGlobals);
    return __assign(__assign({}, roundingGlobals), aliases);
};
//# sourceMappingURL=rounding.js.map